import React, { Component } from "react";
import { bindActionCreators } from "redux";

import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";

import InstagramManagementView from "./InstagramManagementView";
import { getInstagramList } from "../../../../store/InstagramManagement/InstagramManagementActions";
import {
  getRoleList,
  updateRowsPerPage,
} from "../../../../store/master/masterActions";

class InstagramManagementContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      rowsPerPage: { label: "10", value: "10" },
      currentPage: 1,
    };

    this.handleTableRowsChange = this.handleTableRowsChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    //
    this.onChangeSearchInput = this.onChangeSearchInput.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
  }

  componentDidUpdate() {}

  componentDidMount() {
    this.props.getInstagramList();
  }

  componentWillUnmount() {}

  //--------------------------field handlers

  handleTableRowsChange = (value) => {
    this.setState((prev) => ({ ...prev, rowsPerPage: value, currentPage: 1 }));
    // this.props.updateRowsPerPage(value);
    const data = {};
    this.props.getInstagramList(data, 1, value?.value);
  };

  handleChangePage = (page) => {
    this.setState((prev) => ({ ...prev, currentPage: page }));
    const data = {};
    this.props.getInstagramList(data, page, this.state.rowsPerPage?.value);
  };

  // //--------------------------APIs
  // onChangeSearchInput = (e) => {
  //   const { value } = e.target;
  //   const data = { title: value };
  //   this.props.getInstagramList(data);
  // };

  //--------------------------Search videos
  onChangeSearchInput = (e) => {
    const { value } = e.target;
    this.setState((prev) => ({
      ...prev,
      fields: { ...prev.fields, searchValue: value },
    }));
  };

  onClickSearch = () => {
    const data = { caption: this.state?.fields?.searchValue };
    this.props.getInstagramList(data);
  };

  render() {
    //  --------------------------dropdown options

    const rowsPerPageDropDownOptions = [
      { label: "10", value: 10 },
      { label: "15", value: 15 },
      { label: "20", value: 20 },
      { label: "25", value: 25 },
      { label: "30", value: 30 },
    ];

    return (
      <InstagramManagementView
        //all the states
        instagramList={this.props.instagramList}
        showRowsPerPage={this.props.showRowsPerPage}
        currentPage={this.state.currentPage}
        //input handler
        onChangeSearchInput={this.onChangeSearchInput}
        handleTableRowsChange={this.handleTableRowsChange}
        handleChangePage={this.handleChangePage}
        //API's
        onClickSearch={this.onClickSearch}
        //dropdown options
        // rowsPerPageDropDownOptions={this.rowsPerPageDropDownOptions}
        rowsPerPageDropDownOptions={rowsPerPageDropDownOptions}
      />
    );
  }
}

InstagramManagementContainer.propTypes = {};

const mapStateToProps = (state) => ({
  instagramList: state.instagramManagement.instagramList,
  showRowsPerPage: state.master.showRowsPerPage,
});

export default connect(mapStateToProps, {
  getInstagramList,
  //
  updateRowsPerPage,
})(InstagramManagementContainer);
